const categories = document.querySelectorAll('.m-companyinfo-data__category');
const tabs = document.querySelectorAll('.m-companyinfo-data__tab');
const dropdowns = document.querySelectorAll('.m-companyinfo-data__mobile-header');

function initCompanyInfo() {

    const scroll = document.querySelector('.m-companyinfo-data__category-scroll');
    const innerCategories = document.querySelector('.m-companyinfo-data__categories--inner');

    if(scroll) {
        scroll.addEventListener('click', scrollDown);
    }

    if(innerCategories) {
        displayArrow();
    }

    categories.forEach((category) => {
        category.addEventListener('click', function(){
            switchTabs(category); 
        });
    });

    dropdowns.forEach((dropdown) => {
        dropdown.addEventListener('click', function(){
            openDropdown(dropdown); 
        });
    });

    function switchTabs(category) {

        //Swap current state from the category
        const current_cat = document.querySelector('.m-companyinfo-data__category.current');

        if(current_cat) {
            current_cat.classList.remove('current');
        }

        category.classList.add('current');

        //Swap current state from the tabs
        const current_tab = document.querySelector('.m-companyinfo-data__tab.current');

        if(current_tab) {
            current_tab.classList.remove('current');
        }

        const openinig_tab = document.querySelector('.m-companyinfo-data__tab[data-tab="' + category.dataset.tab + '"]');

        if(openinig_tab) {
            openinig_tab.classList.add('current');
        }
    }

    function openDropdown(dropdown) {
        const parent = dropdown.parentElement;
        
        if(parent.classList.contains('active')) {
            parent.classList.remove('active');
        } else {
            parent.classList.add('active');
        }
    }

    function scrollDown() {
        
        const element = document.querySelector('.m-companyinfo-data__categories--inner');

        element.scrollBy({
            top: 256,
            behavior: 'smooth',
        });
    }

    function displayArrow() {

        if(innerCategories.clientHeight > 570) {
            document.querySelector('.m-companyinfo-data__category-scroll').classList.add('active');
        }
    }

}

if(categories && tabs) {
    initCompanyInfo();
}
